import {AppThunk} from '../../index';
import {themeSlice} from '../../../reducers/runtime/theme';
import {storage, StorageKeys} from '../../../../shared/storage';
import {ThemeSettings} from '../../../../shared/theme/interface';

export const setThemeProperty =
  (field: StorageKeys & keyof ThemeSettings, value: unknown): AppThunk =>
  (dispatch) => {
    dispatch(themeSlice.actions.changeThemeProperty({field, value}));
  };

export const changeThemeProperty =
  (field: string, value: unknown): AppThunk =>
  (dispatch) => {
    dispatch(themeSlice.actions.changeThemeProperty({field, value}));
    storage.setItem(field as StorageKeys, value, false);
  };
